import { withTranslation } from 'react-i18next';
import { DEFAULT_NAMESPACE } from 'services/i18n';

const defaultNamespaces = [DEFAULT_NAMESPACE, 'accessibility', 'link'];

export default (namespaces = []) =>
  (WrappedComponent) =>
    withTranslation(defaultNamespaces.concat(namespaces))(WrappedComponent);
